import CardPopupCheckout from './CardPopupCheckout';

export default CardPopupCheckout;
